export * from './utils/is'
export * from './utils/show'
export * from './utils/show-type'
export * from './utils/type'
export * from './utils/union-type'
export * from './utils/dispatch'
export * from './dispatchers'
export * from './types/Any'
export * from './types/Array'
export * from './types/Function'
export * from './types/Promise'
export * from './types/Maybe'
export * from './types/Number'
export * from './types/HTTP'
export * from './plugins'
export * from './services'
export * from './helpers'

export function debounce(func, wait, immediate) {
  let timeout
  return function () {
    // eslint-disable-next-line
    const context = this,
      // eslint-disable-next-line
      args = arguments
    const later = function () {
      timeout = null
      if (!immediate) func.apply(context, args)
    }
    const callNow = immediate && !timeout
    clearTimeout(timeout)
    timeout = setTimeout(later, wait)
    if (callNow) func.apply(context, args)
  }
}
